var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import NP from 'number-precision';
import { isNumber } from '@arco-design/web-react/lib/_util/is';
import cs from 'classnames';
import { useConfigContext } from '../config-provider';
import useMergeValue from '@arco-design/web-react/lib/_util/hooks/useMergeValue';
import Textarea from '@arco-design/web-react/es/Input/textarea';
NP.enableBoundaryChecking(false);
export var InputNumberAutosize = function (props, ref) {
    var _a;
    var className = props.className, style = props.style, disabled = props.disabled, error = props.error, placeholder = props.placeholder, prefix = props.prefix, precision = props.precision, min = props.min, max = props.max, parser = props.parser, formatter = props.formatter, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange;
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-input-number";
    var _b = useState(''), inputValue = _b[0], setInputValue = _b[1];
    var _c = useMergeValue(undefined, {
        // eslint-disable-next-line react/destructuring-assignment
        defaultValue: 'defaultValue' in props ? props.defaultValue : undefined,
        // eslint-disable-next-line react/destructuring-assignment
        value: 'value' in props ? props.value : undefined,
    }), value = _c[0], setValue = _c[1], stateValue = _c[2];
    var refIsInitial = useRef(true);
    var refUserInputting = useRef(false);
    var refInput = useRef(null);
    useImperativeHandle(ref, function () { return refInput.current; }, []);
    var getLegalValue = function (changedValue) {
        var finalValue = Number(changedValue);
        if (changedValue == null) {
            finalValue = undefined;
        }
        else if (!isNumber(finalValue)) {
            finalValue = changedValue === '-' ? changedValue : '';
        }
        if (min != null && Number(finalValue) < min) {
            finalValue = min;
        }
        if (max != null && Number(finalValue) > max) {
            finalValue = max;
        }
        return isNumber(finalValue)
            ? isNumber(precision)
                ? Number(finalValue.toFixed(precision))
                : finalValue
            : undefined;
    };
    useEffect(function () {
        setValue(getLegalValue(value));
    }, [min, max]);
    useEffect(function () {
        if (!refIsInitial.current) {
            var newValue = Number(stateValue);
            onChange && isNumber(newValue) && onChange(newValue);
        }
        refIsInitial.current = false;
    }, [stateValue]);
    var getDisplayInputValue = function () {
        var _value;
        if (refUserInputting.current) {
            _value = inputValue;
        }
        else if (isNumber(value) && isNumber(precision)) {
            _value = value.toFixed(precision);
        }
        else if (value == null) {
            _value = '';
        }
        else {
            _value = value.toString();
        }
        return formatter ? formatter(_value) : _value;
    };
    var inputEventHandlers = {
        onChange: function (value) {
            refUserInputting.current = true;
            var targetValue = String(value).trim().replace(/。/g, '.');
            targetValue = (parser ? parser(targetValue) : targetValue);
            if (isNumber(Number(targetValue)) || targetValue === '-' || !targetValue) {
                var formatValue = getLegalValue(targetValue);
                setInputValue(targetValue);
                setValue(formatValue);
            }
        },
        onFocus: onFocus,
        onBlur: function (e) {
            var formatValue = getLegalValue(value);
            setValue(formatValue);
            setInputValue("" + formatValue);
            refUserInputting.current = false;
            onBlur && onBlur(e);
        },
    };
    return (React.createElement("div", { className: cs(prefixCls + "-autosize-wrapper", (_a = {}, _a[prefixCls + "-autosize-wrapper-with-prefix"] = prefix, _a)) },
        React.createElement("div", { className: prefixCls + "-autosize-prefix" }, prefix),
        React.createElement(Textarea, __assign({}, inputEventHandlers, { autoSize: true, style: style, className: cs(prefixCls, className, prefixCls + "-autosize"), ref: refInput, error: error, disabled: disabled, value: getDisplayInputValue(), placeholder: placeholder }))));
};
var InputNumberAutoSizeComponent = React.forwardRef(InputNumberAutosize);
InputNumberAutoSizeComponent.displayName = 'InputNumberAutoSize';
InputNumberAutoSizeComponent.defaultProps = {
    max: Infinity,
    min: -Infinity,
    disabled: false,
    parser: function (input) { return input.replace(/[^\w.-]+/g, ''); },
};
export default InputNumberAutoSizeComponent;
//# sourceMappingURL=input-number-autosize.js.map